import Swiper, { Navigation, Pagination } from 'swiper';

// Configure Swiper to use modules
Swiper.use([Navigation, Pagination]);


// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


jQuery(window).on('load', function() {
	jQuery('html').removeClass('preload');
});


// Throttle function: Input as function which needs to be throttled and delay is the time interval in milliseconds
var timerId;
var throttleFunction = function (func, delay) {
	// If setTimeout is already scheduled, no need to do anything
	if (timerId) {
		return
	}

	// Schedule a setTimeout after delay seconds
	timerId = setTimeout(function () {
		func()

		// Once setTimeout function execution is finished, timerId = undefined so that in <br>
		// the next scroll event function execution can be scheduled by the setTimeout
		timerId = undefined;
	}, delay)
}




jQuery(document).ready(function() {


	//LOAD Effects

	jQuery('.brands__top').addClass('fading fading--up');
	jQuery('.brands h2').addClass('fading fading--up');
	jQuery('.brands__triple').addClass('fading fading--up');

	jQuery('.cal_japan__top').addClass('fading fading--up');
	jQuery('.cal_japan__stats .employees').addClass('fading fading--up');
	jQuery('.cal_japan__stats .countries').addClass('fading fading--up');
	jQuery('.cal_japan__bottom').addClass('fading fading--up');

	jQuery('.careers__left').addClass('fading fading--up');
	jQuery('.careers__right').addClass('fading fading--up');

	jQuery('.text_block h4').addClass('fading fading--up');
	jQuery('.text_block h3').addClass('fading fading--up');
	jQuery('.text_block__top').addClass('fading fading--up');
	jQuery('.text_block__bottom').addClass('fading fading--up');

	jQuery('.map__left').addClass('fading fading--up');
	jQuery('.map__right').addClass('fading fading--up');

	jQuery('.brand_content h1').addClass('fading fading--up');
	jQuery('.brand_content__text').addClass('fading fading--up');

	jQuery('.brand_slider .swiper-wrap').addClass('fading fading--up');


	jQuery('.narrow_top h2').addClass('fading fading--up');
	jQuery('.narrow_top__text').addClass('fading fading--up');
	jQuery('.narrow_top__logos_wrap').addClass('fading fading--up');

	jQuery('.narrow_top__graphics__left').addClass('fading fading--up');
	jQuery('.narrow_top__graphics__right').addClass('fading fading--up');

	jQuery('.top_grey_block h3').addClass('fading fading--up');
	jQuery('.top_grey_block p').addClass('fading fading--up');
	jQuery('.top_grey_block__card').addClass('fading fading--up');

	jQuery('.improving h3').addClass('fading fading--up');
	jQuery('.improving p').addClass('fading fading--up');
	jQuery('.improving__image_wrap').addClass('fading fading--up');

	jQuery('.local .container h4').addClass('fading fading--up');
	jQuery('.local .container p').addClass('fading fading--up');

	jQuery('.community .container').addClass('fading fading--up');
	jQuery('.community > img').addClass('fading fading--up');

	jQuery('.vacancies h3').addClass('fading fading--up');
	jQuery('.vacancies .container > p').addClass('fading fading--up');
	jQuery('.vacancies__flex .job').addClass('fading fading--up');

	jQuery(".fading").each(function( index ) {
		var elPos = jQuery(this).offset();
		var elTop = elPos.top - jQuery(document).scrollTop();
		elTop = elTop + jQuery(this).height() * 0.1;
		if (elTop < window.innerHeight * 1) {
			jQuery(this).addClass("faded");
		}
	});

	jQuery(window).scroll(function() {

		jQuery(".fading").each(function( index ) {
			var elPos = jQuery(this).offset();
			var elTop = elPos.top - jQuery(document).scrollTop();
			elTop = elTop + 30;
			if (elTop < window.innerHeight * 0.95) {
				jQuery(this).addClass("faded");
			}
		});

	});





	function resiNav() {
		//jQuery( ".menu" ).before( "<figure></figure>" );
		// jQuery('.sub-menu').prepend('<li class="current_parent"><p></p></li>');

		// var parents = jQuery('.menu-item-has-children');
		// for (var i = 0; i < parents.length; i++) {
		// 	var parentTitle = parents[i].children[0].text;
		// 	var previousParentTitle = parents[i].children[1].children[0].children[0];
		// 	previousParentTitle.innerText = parentTitle;
		// }

		jQuery('.menu-header .menu-item-has-children > a').click(function (e) {
			if (jQuery(window).width() < 920) {
				e.preventDefault();
			}
			// console.log(jQuery(this)[0].text);
			jQuery(this).parent().toggleClass('open');
			jQuery(this).next('ul.sub-menu').toggleClass('open');
		});

		jQuery('li.current_parent').click(function() {
			jQuery(this).parent().toggleClass('open');
		});

		jQuery('.resi_button, .resi_over, .menu-header figure').click(function() {
			jQuery('html').toggleClass('js-nav');
			//jQuery('ul.sub-menu').removeClass('open')
		});

	}
	resiNav();

	function toggle_head_classes() {
		console.log(jQuery(window).scrollTop());
		if (jQuery(window).scrollTop() > 50) {
			jQuery('body').addClass('sticky');
		} else {
			jQuery('body').removeClass('sticky');
		}
	}


	toggle_head_classes(); // Run on page load so if refreshing and further down page the header will look right


	jQuery(window).scroll(function() {
		throttleFunction(toggle_head_classes, 80);
	});


	const swiper = new Swiper('.brand_slider .swiper', {
		speed: 400,
		loop: true,
		slidesPerView: 1,
		spaceBetween: 50,
		allowTouchMove: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	jQuery('.swiper .swiper-slide #ingredients').click(function (e) {
		e.preventDefault();
		jQuery(this).closest('.swiper-slide').find('.pop_ingredients').addClass('active');

		jQuery('.swiper-button-prev, .swiper-button-next').addClass('hidden');
	});

	jQuery('.swiper .swiper-slide #nutritionals').click(function (e) {
		e.preventDefault();
		jQuery(this).closest('.swiper-slide').find('.pop_nutritionals').addClass('active');

		jQuery('.swiper-button-prev, .swiper-button-next').addClass('hidden');
	});

	jQuery('.swiper-slide .close').click(function () {
		jQuery(this).parent().removeClass('active');

		jQuery('.swiper-button-prev, .swiper-button-next').removeClass('hidden');
	});


	jQuery('.l_box .bg, .l_box .close').click(function () {
		jQuery('.l_box').removeClass('active');
	});

	if (jQuery('body').hasClass('page-template-page-brand')){
		jQuery('#menu-item-11').addClass('open');
		jQuery('#menu-item-11 .sub-menu').addClass('open');
	}

	jQuery('.accordion__single__title').click(function () {
		jQuery(this).parent().toggleClass('open');
	});


	

	jQuery('*[data-scroll]').click(function() {
		var target = jQuery(this).data('scroll');

		jQuery('html, body').animate({
			 scrollTop: jQuery(target).offset().top - 129
		}, 300);
	});

	// Remove error message form CF7 when input is clicked
	if (jQuery('.wpcf7').length > 0) {
		jQuery('.wpcf7 input, .wpcf7 teaxtarea, .wpcf7 select').click(function(){
			jQuery(this).next('.wpcf7-not-valid-tip').remove();
		});
	}


	document.addEventListener( 'wpcf7mailsent', function( event ) {
		console.log(event);
	}, false );

});
